module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b0f62f01106e1485949e203cb8df4134.png";